module.exports = __webpack_public_path__ + "img/chip.9e524492.png";